import React, { useState, useEffect, useRef, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Box, Fab, Grid, Paper, Skeleton } from '@mui/material'


import OverallWellnessScore from "../personalreport/OverallWellnessScore";

//import KeyAreaNavBar from "./partials/personalreport/KeyAreaNavBar";
import { motion, AnimatePresence } from "framer-motion/dist/framer-motion"

import { useReactToPrint } from "react-to-print";



import HealthAge from "../personalreport/HealthAge";
import Information from "../personalreport/Information";
import WellnessScoreSingle from "../personalreport/WellnessScoreSingle";
import InformationSingle from "../personalreport/InformationSingle";


const motionVariants = {
    hidden: { opacity: 0, x: 0, y: 0 },
    show: {
        opacity: 1, x: 0, y: 0,
        transition: {
            delay: 0.1,
            duration: 0.5,
        }
    }
}

const PersonalReportInfoAndOverall = (props) => {
    const { component } = props
    const { settings, PrintView } = props.otherprops


    return (
        <Grid item xs={12}>

            <Grid container spacing={2} alignItems="stretch">

                <Grid item lg={6} md={6} sm={12} xs={12} justifyContent="center" alignItems="center" sx={{ padding: '10px' }}>
                    <motion.div variants={PrintView === true ? { hidden: { opacity: 1 } } : motionVariants} initial="hidden" animate="show" style={{ height: '100%' }}>

                        <Paper elevation={1} sx={{ padding: '24px', height: '100%' }}>
                            <div>
                               <InformationSingle component={component.AssessmentInfo} otherprops={props.otherprops}/>

                            </div>

                        </Paper>
                    </motion.div>
                </Grid>

                <Grid item lg={6} md={6} sm={12} xs={12} justifyContent="center" alignItems="center" sx={{ padding: '10px' }}>
                    <motion.div variants={PrintView === true ? { hidden: { opacity: 1 } } : motionVariants} initial="hidden" animate="show" style={{ height: '100%' }}>

                        <Paper elevation={1} sx={{ padding: '24px', height: '100%' }}>
                            <div>
                                <WellnessScoreSingle component={component.OverallScore} otherprops={props.otherprops}/>
                            </div>

                        </Paper>
                    </motion.div>
                </Grid>

            </Grid>
        </Grid>
    )

}
export default PersonalReportInfoAndOverall